<template>
  <div class="auth-code-container">
    <van-nav-bar
      title="授权码生成"
      left-arrow
      :fixed="true"
      :border="true"
      @click-left="$router.go(-1)"
    />
    
    <div class="content">
      <van-cell-group inset>
        <van-cell title="授权码" :value="authCode" v-if="authCode">
          <template #right-icon>
            <div class="copy-wrapper" @click="copyAuthCode">
              <van-icon name="copy" class="copy-icon" />
              <span class="copy-text">复制</span>
            </div>
          </template>
        </van-cell>
        <van-cell title="过期时间" v-if="countdown > 0">
          <template #default>
            <span :class="{ 'expiring': countdown <= 30 }">{{ countdown|formatCountdown }}</span>
          </template>
        </van-cell>
      </van-cell-group>

      <div class="button-group">
        <van-button 
          type="primary" 
          block 
          :loading="loading"
          @click="generateAuthCode"
        >
          {{ authCode ? '重新生成' : '生成授权码' }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuthCode } from '@/service/api/system/merchant'
import { Toast } from 'vant'

export default {
  name: 'AuthCode',
  data() {
    return {
      loading: false,
      authCode: '',
      countdown: 0,
      timer: null,
      expireTime: 0, // 过期时间戳
      updateTimer: null // 用于更新显示的定时器
    }
  },
  filters: {
    formatCountdown(value) {
      const minutes = Math.floor(value / 60)
      const seconds = value % 60
      return `${minutes}:${seconds.toString().padStart(2, '0')}`
    }
  },
  methods: {
    startCountdown() {
      // 清除可能存在的旧定时器
      if (this.updateTimer) {
        clearInterval(this.updateTimer)
      }
      
      // 设置过期时间戳（当前时间 + 3分钟）
      this.expireTime = Date.now() + 180 * 1000
      
      // 立即更新一次倒计时
      this.updateCountdown()
      
      // 每秒更新显示（这个定时器只用于更新显示，不影响实际倒计时）
      this.updateTimer = setInterval(() => {
        this.updateCountdown()
      }, 1000)
    },
    
    updateCountdown() {
      const now = Date.now()
      const remaining = Math.max(0, Math.floor((this.expireTime - now) / 1000))
      
      this.countdown = remaining
      
      if (remaining <= 0) {
        // 倒计时结束
        this.authCode = ''
        clearInterval(this.updateTimer)
        this.updateTimer = null
        Toast('授权码已过期')
      }
    },
    
    async generateAuthCode() {
      try {
        this.loading = true
        const res = await getAuthCode()
        if (res.code === 200) {
          this.authCode = res.data
          this.startCountdown() // 开始倒计时
          Toast.success('授权码生成成功')
        } else {
          Toast.fail(res.msg || '生成失败')
        }
      } catch (error) {
        Toast.fail('生成失败，请稍后重试')
        console.error('生成授权码失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    copyAuthCode() {
      if (!this.authCode) return
      navigator.clipboard.writeText(this.authCode)
        .then(() => {
          Toast.success('复制成功')
        })
        .catch(() => {
          Toast.fail('复制失败')
        })
    }
  },
  
  // 页面激活时更新倒计时
  activated() {
    if (this.expireTime > 0) {
      this.updateCountdown()
    }
  },
  
  // 页面隐藏时暂停更新显示
  deactivated() {
    if (this.updateTimer) {
      clearInterval(this.updateTimer)
      this.updateTimer = null
    }
  },
  
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.updateTimer) {
      clearInterval(this.updateTimer)
      this.updateTimer = null
    }
  }
}
</script>

<style lang="less" scoped>
.auth-code-container {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-top: 46px;
}

.content {
  padding: 16px;
}

.button-group {
  margin-top: 24px;
}

.copy-wrapper {
  display: flex;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  
  &:active {
    opacity: 0.7;
  }
}

.copy-icon {
  font-size: 18px;
  color: #1989fa;
  margin-right: 4px;
}

.copy-text {
  font-size: 14px;
  color: #1989fa;
}

.expiring {
  color: #ee0a24;
}
</style> 